import React, { useMemo } from "react"
import styles from "./styles.module.scss"
import { useSearchParams } from "react-router-dom"
import Loader from "components/loader"
import { Input } from "antd"
import { useTranslation } from "react-i18next"
import EventItem from "./event-item"
import { useEventId, usePresenceId } from "pages/events"
import { useExecutionMember, useMemberEvents } from "../../queries"
import { useEvent } from "pages/events/queries"

const ACTIVITY_PARAM = "activity"

const MemberEvents: React.FC = () => {
  const { t } = useTranslation()
  let [searchParams, setSearchParams] = useSearchParams()
  const presenceId = usePresenceId() // or memberId when the event status is "approved"
  const eventId = useEventId()
  const event = useEvent(eventId!)
  const executionMember = useExecutionMember(eventId!, presenceId!, {
    enabled: event.data?.status === "execution",
  })

  const events = useMemberEvents(
    event.data?.status === "execution"
      ? executionMember.data?.member_id!
      : presenceId!,
    {
      enabled:
        event.isSuccess &&
        (event.data?.status === "approved" || executionMember.isSuccess),
    }
  )

  const filteredEvents = useMemo(() => {
    if (searchParams.get(ACTIVITY_PARAM)) {
      return (
        events.data
          ?.filter(
            (element) =>
              element.name
                .toLowerCase()
                .startsWith(searchParams.get(ACTIVITY_PARAM)!.toLowerCase()) &&
              element
          )
          .sort((a, b) => a.name.localeCompare(b.name)) || []
      )
    }
    return events.data || []
  }, [events.data, searchParams])

  return (
    <>
      <div className={styles.searchInputContainer}>
        <Input
          className={styles.searchInput}
          size="large"
          placeholder={t("global.search")}
          value={searchParams.get(ACTIVITY_PARAM) ?? ""}
          onChange={(e) => {
            e.target.value
              ? searchParams.set(ACTIVITY_PARAM, e.target.value)
              : searchParams.delete(ACTIVITY_PARAM)
            setSearchParams(searchParams, { replace: true })
          }}
        />
      </div>
      {events.isLoading ? (
        <Loader />
      ) : (
        <div className={styles.container}>
          <div className={styles.members}>
            {filteredEvents.map((item) => (
              <EventItem key={item.id} item={item} />
            ))}
          </div>
        </div>
      )}
    </>
  )
}

export default MemberEvents
